(function IIFE (): void {
const details = document.body.querySelector<HTMLDetailsElement>('details.exclusivity-badge')

if (!details) {
  return
}

const closeButton = details.querySelector<HTMLButtonElement>('button.exclusivity-badge-close-button')

if (!closeButton) {
  return
}

closeButton.addEventListener('click', () => {
  details.open = false
})
})()
